import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from '@/stores/session';

export function AdminRoute() {
  const user = useSession((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;
  return <Outlet />;
}
